[
 {
  "id": "deepseek-v4-flash-vision-exp",
  "label": "DeepSeek V4 Flash Vision Exp (MoE)",
  "group": "Large MoE",
  "params": 304.646824126,
  "activeParams": 15,
  "hidden": 4096,
  "layers": 43,
  "vocab": 129280,
  "maxContext": 1048576,
  "routing": {
   "experts": 256,
   "active": 6
  },
  "kv": [
   {
    "layers": 43,
    "width": 512,
    "window": 128,
    "fp8Bytes": 584
   },
   {
    "layers": 21,
    "width": 512,
    "ratio": 4,
    "fp8Bytes": 584
   },
   {
    "layers": 20,
    "width": 512,
    "ratio": 128,
    "fp8Bytes": 584
   },
   {
    "layers": 21,
    "width": 128,
    "ratio": 4,
    "fixedBytes": 132
   }
  ],
  "stateBytesPerSeq": 12206080,
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 167819404368
  },
  "fp8Kv": true,
  "arch": "43 layers · 512-wide latent, 128-token window + compression (21 layers 4×, 20 layers 128×)",
  "repo": "deepseek-ai/DeepSeek-V4-Flash-Vision-Exp",
  "released": "2026-08-31",
  "parts": {
   "mtp": 19.846,
   "vision": 0.001,
   "experts": 277.025,
   "odd": 0.002
  },
  "mtpBytes": 10862841372
 },
 {
  "id": "qwen3.8-2.4t-a95b",
  "label": "Qwen3.8 2.4T-A95B (MoE)",
  "group": "Large MoE",
  "params": 2446.182725504,
  "activeParams": 95,
  "hidden": 8192,
  "layers": 92,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 23,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 587292672,
  "arch": "92 layers · 23 full attention (4 KV × 256) · 69 linear attention",
  "repo": "Qwen/Qwen3.8-2.4T-A95B",
  "released": "2026-08-08",
  "parts": {
   "mtp": 26.378,
   "experts": 2370.822,
   "odd": 0.006
  },
  "mtpBytes": 52756055040,
  "routing": {
   "experts": 512,
   "active": 10
  }
 },
 {
  "id": "ornith-1.5-397b",
  "label": "Ornith 1.5 397B (MoE)",
  "group": "Large MoE",
  "params": 403.397928944,
  "activeParams": 18,
  "hidden": 4096,
  "layers": 60,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 15,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 192061440,
  "arch": "60 layers · 15 full attention (2 KV × 256) · 45 linear attention",
  "repo": "ornith-ai/Ornith-1.5-397B",
  "released": "2026-08-18",
  "parts": {
   "mtp": 6.596,
   "vision": 0.456,
   "experts": 386.547,
   "odd": 0.002
  },
  "mtpBytes": 13191136256,
  "routing": {
   "experts": 512,
   "active": 10
  }
 },
 {
  "id": "ornith-1.5-35b-a3b",
  "label": "Ornith 1.5 35B-A3B (MoE)",
  "group": "Hybrid linear attention",
  "params": 35.951822704,
  "activeParams": 3,
  "hidden": 2048,
  "layers": 40,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 64389120,
  "arch": "40 layers · 10 full attention (2 KV × 256) · 30 linear attention",
  "repo": "ornith-ai/Ornith-1.5-35B-A3B",
  "released": "2026-08-18",
  "parts": {
   "mtp": 0.845,
   "vision": 0.447,
   "experts": 32.212,
   "odd": 0.001
  },
  "mtpBytes": 1689281536,
  "routing": {
   "experts": 256,
   "active": 8
  }
 },
 {
  "id": "ornith-1.5-9b",
  "label": "Ornith 1.5 9B",
  "group": "Hybrid linear attention",
  "params": 9.653104368,
  "hidden": 4096,
  "layers": 32,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 8,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 51511296,
  "arch": "32 layers · 8 full attention (4 KV × 256) · 24 linear attention",
  "repo": "ornith-ai/Ornith-1.5-9B",
  "released": "2026-08-18",
  "parts": {
   "mtp": 0.243,
   "vision": 0.456,
   "odd": 0.001
  },
  "mtpBytes": 486581248
 },
 {
  "id": "atria-dawn-preview",
  "label": "Atria Dawn Preview (MoE)",
  "group": "Large MoE",
  "params": 753.32994048,
  "activeParams": 42,
  "hidden": 6144,
  "layers": 78,
  "vocab": 154880,
  "maxContext": 1048576,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 78,
    "width": 576,
    "fp8Bytes": 656
   },
   {
    "layers": 21,
    "width": 128,
    "fixedBytes": 132
   }
  ],
  "arch": "78 layers · MLA (512 + 64 latent) on 78 · indexer keys on 21",
  "repo": "internlm/Atria-Dawn-Preview",
  "released": "2026-09-11",
  "parts": {
   "mtp": 9.953,
   "experts": 724.776
  },
  "mtpBytes": 19905841664
 },
 {
  "id": "intern-s2-397b",
  "label": "Intern S2 397B (MoE)",
  "group": "Large MoE",
  "params": 403.423094768,
  "activeParams": 18,
  "hidden": 4096,
  "layers": 60,
  "vocab": 251392,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 15,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 192061440,
  "arch": "60 layers · 15 full attention (2 KV × 256) · 45 linear attention",
  "repo": "internlm/Intern-S2-397B",
  "released": "2026-09-13",
  "parts": {
   "mtp": 6.596,
   "vision": 0.456,
   "experts": 386.547,
   "odd": 0.002
  },
  "mtpBytes": 13191136256,
  "routing": {
   "experts": 512,
   "active": 10
  }
 },
 {
  "id": "clef",
  "label": "Clef",
  "group": "Hybrid linear attention",
  "params": 27.35672856,
  "hidden": 5120,
  "layers": 64,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 16,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 153944064,
  "arch": "64 layers · 16 full attention (4 KV × 256) · 48 linear attention",
  "repo": "Cloudflare/clef",
  "released": "2026-09-30",
  "parts": {
   "vision": 0.461,
   "odd": 0.002
  }
 },
 {
  "id": "clef-flash",
  "label": "Clef Flash",
  "group": "Hybrid linear attention",
  "params": 9.409813744,
  "hidden": 4096,
  "layers": 32,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 8,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 51511296,
  "arch": "32 layers · 8 full attention (4 KV × 256) · 24 linear attention",
  "repo": "Cloudflare/clef-flash",
  "released": "2026-09-30",
  "parts": {
   "vision": 0.456,
   "odd": 0.001
  }
 },
 {
  "id": "d1-3b",
  "label": "D1 3B",
  "group": "Hybrid linear attention",
  "params": 3.123483888,
  "hidden": 2048,
  "layers": 30,
  "vocab": 128000,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 8,
    "width": 1024,
    "tpHeads": 8
   }
  ],
  "stateBytesPerSeq": 270336,
  "arch": "30 layers · 8 full attention (8 KV × 64) · 22 short-convolution layers",
  "repo": "LiquidAI/d1-3B",
  "released": "2026-10-05",
  "parts": {
   "vision": 0.426
  }
 },
 {
  "id": "humanizer",
  "label": "Humanizer",
  "group": "Sliding-window attention",
  "params": 11.959730224,
  "hidden": 3840,
  "layers": 48,
  "vocab": 262144,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 8,
    "width": 1024,
    "tpHeads": 1
   },
   {
    "layers": 40,
    "width": 4096,
    "tpHeads": 8,
    "window": 1024
   }
  ],
  "arch": "48 layers · 8 full attention (1 KV × 512) · 40 sliding-window layers (1024 tokens, 8 KV × 256)",
  "repo": "jialinyyzz/humanizer",
  "released": "2026-09-11",
  "parts": {
   "vision": 0.052
  }
 },
 {
  "id": "jev-27b-vl",
  "label": "JEV 27B VL",
  "group": "Hybrid linear attention",
  "params": 27.781427952,
  "hidden": 5120,
  "layers": 64,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 16,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 153944064,
  "arch": "64 layers · 16 full attention (4 KV × 256) · 48 linear attention",
  "repo": "autotrust/JEV-27B-VL",
  "released": "2026-09-30",
  "parts": {
   "mtp": 0.425,
   "vision": 0.461,
   "odd": 0.002
  },
  "mtpBytes": 849398784
 },
 {
  "id": "mellum2.1-12b-a2.5b",
  "label": "Mellum2.1 12B-A2.5B (MoE)",
  "group": "Sliding-window attention",
  "params": 12.149923072,
  "activeParams": 2.5,
  "hidden": 2304,
  "layers": 28,
  "vocab": 98304,
  "maxContext": 131072,
  "routing": {
   "experts": 64,
   "active": 8
  },
  "kv": [
   {
    "layers": 7,
    "width": 1024,
    "tpHeads": 4
   },
   {
    "layers": 21,
    "width": 1024,
    "tpHeads": 4,
    "window": 1024
   }
  ],
  "arch": "28 layers · 7 full attention (4 KV × 128) · 21 sliding-window layers (1024 tokens, 4 KV × 128)",
  "repo": "JetBrains/Mellum2.1-12B-A2.5B-Thinking",
  "released": "2026-09-20",
  "parts": {
   "experts": 11.098,
   "odd": 3.699
  }
 },
 {
  "id": "lightonocr-3-4b",
  "label": "LightOnOCR-3 4B",
  "group": "Hybrid linear attention",
  "params": 4.539265536,
  "hidden": 2560,
  "layers": 32,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 8,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 51511296,
  "tiedEmbeddings": true,
  "arch": "32 layers · 8 full attention (4 KV × 256) · 24 linear attention",
  "repo": "lightonai/LightOnOCR-3-4B",
  "released": "2026-10-06",
  "parts": {
   "vision": 0.334,
   "odd": 0.001
  }
 },
 {
  "id": "spark-x2.5-4b",
  "label": "Spark-X2.5 4B",
  "group": "Sliding-window attention",
  "params": 4.11207936,
  "hidden": 2560,
  "layers": 36,
  "vocab": 131072,
  "maxContext": 1048576,
  "kv": [
   {
    "layers": 9,
    "width": 2048,
    "tpHeads": 4
   },
   {
    "layers": 27,
    "width": 2048,
    "tpHeads": 4,
    "window": 512
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 9 full attention (4 KV × 256) · 27 sliding-window layers (512 tokens, 4 KV × 256)",
  "repo": "XHToken/Spark-X2.5-4B",
  "released": "2026-08-24"
 },
 {
  "id": "agnes-3.0-qwen",
  "label": "Agnes-3.0-Qwen (MoE)",
  "group": "Hybrid linear attention",
  "params": 179.999981459,
  "activeParams": 7.8,
  "hidden": 2560,
  "layers": 48,
  "vocab": 248320,
  "maxContext": 1048576,
  "routing": {
   "experts": 512,
   "active": 10
  },
  "kv": [
   {
    "layers": 12,
    "width": 1024,
    "tpHeads": 2
   },
   {
    "layers": 12,
    "width": 128,
    "ratio": 4,
    "fixedBytes": 256
   }
  ],
  "stateBytesPerSeq": 115458048,
  "arch": "48 layers · 12 full attention (2 KV × 256) · indexer keys per 4-token block · 36 linear attention",
  "repo": "Agnes-AI/Agnes-3.0-Qwen",
  "released": "2026-10-10",
  "parts": {
   "mtp": 2.607,
   "vision": 0.449,
   "experts": 120.796,
   "lookup": 51.2,
   "odd": 40.663
  },
  "mtpBytes": 5214301696
 },
 {
  "id": "youtu-parsing-omni",
  "label": "Youtu-Parsing-Omni",
  "group": "Dense",
  "params": 5.334472192,
  "hidden": 2560,
  "layers": 40,
  "vocab": 133632,
  "maxContext": 1048576,
  "kv": [
   {
    "layers": 40,
    "width": 576
   }
  ],
  "arch": "40 layers · MLA (512 + 64 latent) on 40",
  "repo": "tencent/Youtu-Parsing-Omni",
  "released": "2026-10-09",
  "parts": {
   "vision": 0.481
  }
 },
 {
  "id": "agnes-3.0-flash",
  "label": "Agnes-3.0-Flash",
  "group": "Hybrid linear attention",
  "params": 33.09050168,
  "hidden": 5120,
  "layers": 72,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 18,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 173187072,
  "arch": "72 layers · 18 full attention (4 KV × 256) · 54 linear attention",
  "repo": "Agnes-AI/Agnes-3.0-Flash",
  "released": "2026-09-11",
  "parts": {
   "mtp": 0.425,
   "vision": 0.461,
   "odd": 0.002
  },
  "mtpBytes": 849398784
 },
 {
  "id": "mistral-7b-v0.3",
  "label": "Mistral 7B-v0.3",
  "group": "Dense",
  "params": 7.248023552,
  "hidden": 4096,
  "layers": 32,
  "vocab": 32768,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 32,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "32 layers · 32 full attention (8 KV × 128)",
  "repo": "mistralai/Mistral-7B-Instruct-v0.3",
  "released": "2024-05-22"
 },
 {
  "id": "mistral-small-3.1-24b",
  "label": "Mistral-Small-3.1 24B",
  "group": "Dense",
  "params": 24.01136128,
  "hidden": 5120,
  "layers": 40,
  "vocab": 131072,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 40,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "40 layers · 40 full attention (8 KV × 128)",
  "repo": "mistralai/Mistral-Small-3.1-24B-Instruct-2503",
  "released": "2025-03-11",
  "parts": {
   "vision": 0.439
  }
 },
 {
  "id": "mistral-nemo",
  "label": "Mistral-Nemo",
  "group": "Dense",
  "params": 12.2477824,
  "hidden": 5120,
  "layers": 40,
  "vocab": 131072,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 40,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "40 layers · 40 full attention (8 KV × 128)",
  "repo": "mistralai/Mistral-Nemo-Instruct-2407",
  "released": "2024-07-17"
 },
 {
  "id": "ministral-8b",
  "label": "Ministral 8B",
  "group": "Sliding-window attention",
  "params": 8.019808256,
  "hidden": 4096,
  "layers": 36,
  "vocab": 131072,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 9,
    "width": 2048,
    "tpHeads": 8
   },
   {
    "layers": 27,
    "width": 2048,
    "tpHeads": 8,
    "window": 32768
   }
  ],
  "arch": "36 layers · 9 full attention (8 KV × 128) · 27 sliding-window layers (32768 tokens, 8 KV × 128)",
  "repo": "mistralai/Ministral-8B-Instruct-2410",
  "released": "2024-10-15"
 },
 {
  "id": "deepseek-v3",
  "label": "DeepSeek-V3 (MoE)",
  "group": "Large MoE",
  "params": 684.489845504,
  "activeParams": 37,
  "hidden": 7168,
  "layers": 61,
  "vocab": 129280,
  "maxContext": 163840,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 2048
  },
  "kv": [
   {
    "layers": 61,
    "width": 576
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 688586727753
  },
  "arch": "61 layers · MLA (512 + 64 latent) on 61",
  "repo": "deepseek-ai/DeepSeek-V3",
  "released": "2024-12-25",
  "parts": {
   "mtp": 13.463,
   "experts": 653.909
  },
  "mtpBytes": 15424227552
 },
 {
  "id": "deepseek-coder-7b-v1.5",
  "label": "deepseek-coder 7B-v1.5",
  "group": "Coding models",
  "params": 6.910365696,
  "hidden": 4096,
  "layers": 30,
  "vocab": 102400,
  "maxContext": 4096,
  "kv": [
   {
    "layers": 30,
    "width": 8192,
    "tpHeads": 32
   }
  ],
  "arch": "30 layers · 30 full attention (32 KV × 128)",
  "repo": "deepseek-ai/deepseek-coder-7b-instruct-v1.5",
  "released": "2024-01-25"
 },
 {
  "id": "deepseek-r1-qwen3-8b",
  "label": "DeepSeek-R1-Qwen3 8B",
  "group": "Dense",
  "params": 8.19073536,
  "hidden": 4096,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "36 layers · 36 full attention (8 KV × 128)",
  "repo": "deepseek-ai/DeepSeek-R1-0528-Qwen3-8B",
  "released": "2025-05-29"
 },
 {
  "id": "deepseek-r1-distill-qwen-32b",
  "label": "DeepSeek-R1-Distill-Qwen 32B",
  "group": "Dense",
  "params": 32.763876352,
  "hidden": 5120,
  "layers": 64,
  "vocab": 152064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 64,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "64 layers · 64 full attention (8 KV × 128)",
  "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-32B",
  "released": "2025-01-20"
 },
 {
  "id": "deepseek-v3.1",
  "label": "DeepSeek-V3.1 (MoE)",
  "group": "Large MoE",
  "params": 684.531386,
  "activeParams": 40,
  "hidden": 7168,
  "layers": 61,
  "vocab": 129280,
  "maxContext": 163840,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 61,
    "width": 576
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 688586727753
  },
  "arch": "61 layers · MLA (512 + 64 latent) on 61",
  "repo": "deepseek-ai/DeepSeek-V3.1",
  "released": "2025-08-21",
  "parts": {
   "mtp": 13.463,
   "experts": 653.909
  },
  "mtpBytes": 15424227552
 },
 {
  "id": "deepseek-r1-distill-qwen-14b",
  "label": "DeepSeek-R1-Distill-Qwen 14B",
  "group": "Dense",
  "params": 14.770033664,
  "hidden": 5120,
  "layers": 48,
  "vocab": 152064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 48,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "48 layers · 48 full attention (8 KV × 128)",
  "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-14B",
  "released": "2025-01-20"
 },
 {
  "id": "deepseek-r1-distill-qwen-7b",
  "label": "DeepSeek-R1-Distill-Qwen 7B",
  "group": "Dense",
  "params": 7.615616512,
  "hidden": 3584,
  "layers": 28,
  "vocab": 152064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 28,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "28 layers · 28 full attention (4 KV × 128)",
  "repo": "deepseek-ai/DeepSeek-R1-Distill-Qwen-7B",
  "released": "2025-01-20"
 },
 {
  "id": "deepseek-r1-distill-llama-8b",
  "label": "DeepSeek-R1-Distill-Llama 8B",
  "group": "Dense",
  "params": 8.030261248,
  "hidden": 4096,
  "layers": 32,
  "vocab": 128256,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 32,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "32 layers · 32 full attention (8 KV × 128)",
  "repo": "deepseek-ai/DeepSeek-R1-Distill-Llama-8B",
  "released": "2025-01-20"
 },
 {
  "id": "qwen3-4b",
  "label": "Qwen3 4B",
  "group": "Dense",
  "params": 4.022468096,
  "hidden": 2560,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 131072,
  "yarn": {
   "factor": 4,
   "original": 32768,
   "native": 40960
  },
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 36 full attention (8 KV × 128) · 32K native, 128K with YaRN",
  "repo": "Qwen/Qwen3-4B",
  "released": "2025-04-27"
 },
 {
  "id": "qwen3-8b",
  "label": "Qwen3 8B",
  "group": "Dense",
  "params": 8.19073536,
  "hidden": 4096,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 131072,
  "yarn": {
   "factor": 4,
   "original": 32768,
   "native": 40960
  },
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "36 layers · 36 full attention (8 KV × 128) · 32K native, 128K with YaRN",
  "repo": "Qwen/Qwen3-8B",
  "released": "2025-04-27"
 },
 {
  "id": "qwen2.5-7b",
  "label": "Qwen2.5 7B",
  "group": "Dense",
  "params": 7.615616512,
  "hidden": 3584,
  "layers": 28,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 28,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "28 layers · 28 full attention (4 KV × 128)",
  "repo": "Qwen/Qwen2.5-7B-Instruct",
  "released": "2024-09-16"
 },
 {
  "id": "qwen3-14b",
  "label": "Qwen3 14B",
  "group": "Dense",
  "params": 14.7683072,
  "hidden": 5120,
  "layers": 40,
  "vocab": 151936,
  "maxContext": 131072,
  "yarn": {
   "factor": 4,
   "original": 32768,
   "native": 40960
  },
  "kv": [
   {
    "layers": 40,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "40 layers · 40 full attention (8 KV × 128) · 32K native, 128K with YaRN",
  "repo": "Qwen/Qwen3-14B",
  "released": "2025-04-27"
 },
 {
  "id": "qwen2.5-3b",
  "label": "Qwen2.5 3B",
  "group": "Dense",
  "params": 3.085938688,
  "hidden": 2048,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 36,
    "width": 512,
    "tpHeads": 2
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 36 full attention (2 KV × 128)",
  "repo": "Qwen/Qwen2.5-3B-Instruct",
  "released": "2024-09-17"
 },
 {
  "id": "qwen3.6-27b",
  "label": "Qwen3.6 27B",
  "group": "Hybrid linear attention",
  "params": 27.781427952,
  "hidden": 5120,
  "layers": 64,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 16,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 153944064,
  "arch": "64 layers · 16 full attention (4 KV × 256) · 48 linear attention",
  "repo": "Qwen/Qwen3.6-27B",
  "released": "2026-04-21",
  "parts": {
   "mtp": 0.425,
   "vision": 0.461,
   "odd": 0.002
  },
  "mtpBytes": 849398784
 },
 {
  "id": "qwen3.5-27b",
  "label": "Qwen3.5 27B",
  "group": "Hybrid linear attention",
  "params": 27.781427952,
  "hidden": 5120,
  "layers": 64,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 16,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 153944064,
  "arch": "64 layers · 16 full attention (4 KV × 256) · 48 linear attention",
  "repo": "Qwen/Qwen3.5-27B",
  "released": "2026-02-24",
  "parts": {
   "mtp": 0.425,
   "vision": 0.461,
   "odd": 0.002
  },
  "mtpBytes": 849398784
 },
 {
  "id": "qwen2.5-coder-7b",
  "label": "Qwen2.5-Coder 7B",
  "group": "Coding models",
  "params": 7.615616512,
  "hidden": 3584,
  "layers": 28,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 28,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "28 layers · 28 full attention (4 KV × 128)",
  "repo": "Qwen/Qwen2.5-Coder-7B-Instruct",
  "released": "2024-09-17"
 },
 {
  "id": "qwen2.5-32b",
  "label": "Qwen2.5 32B",
  "group": "Dense",
  "params": 32.763876352,
  "hidden": 5120,
  "layers": 64,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 64,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "64 layers · 64 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen2.5-32B-Instruct",
  "released": "2024-09-17"
 },
 {
  "id": "qwen2.5-coder-14b",
  "label": "Qwen2.5-Coder 14B",
  "group": "Coding models",
  "params": 14.770033664,
  "hidden": 5120,
  "layers": 48,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 48,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "48 layers · 48 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen2.5-Coder-14B-Instruct",
  "released": "2024-11-06"
 },
 {
  "id": "qwen3.5-35b-a3b",
  "label": "Qwen3.5 35B-A3B (MoE)",
  "group": "Hybrid linear attention",
  "params": 35.951822704,
  "activeParams": 3,
  "hidden": 2048,
  "layers": 40,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 64389120,
  "arch": "40 layers · 10 full attention (2 KV × 256) · 30 linear attention",
  "repo": "Qwen/Qwen3.5-35B-A3B",
  "released": "2026-02-24",
  "parts": {
   "mtp": 0.845,
   "vision": 0.447,
   "experts": 32.212,
   "odd": 0.001
  },
  "mtpBytes": 1689281536
 },
 {
  "id": "qwen3-30b-a3b",
  "label": "Qwen3 30B-A3B (MoE)",
  "group": "Mixture of experts",
  "params": 30.532122624,
  "activeParams": 3,
  "hidden": 2048,
  "layers": 48,
  "vocab": 151936,
  "maxContext": 131072,
  "yarn": {
   "factor": 4,
   "original": 32768,
   "native": 40960
  },
  "routing": {
   "experts": 128,
   "active": 8,
   "ffn": 768
  },
  "kv": [
   {
    "layers": 48,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "48 layers · 48 full attention (4 KV × 128) · 32K native, 128K with YaRN",
  "repo": "Qwen/Qwen3-30B-A3B",
  "released": "2025-04-27",
  "parts": {
   "experts": 28.991
  }
 },
 {
  "id": "qwen2.5-14b",
  "label": "Qwen2.5 14B",
  "group": "Dense",
  "params": 14.770033664,
  "hidden": 5120,
  "layers": 48,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 48,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "48 layers · 48 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen2.5-14B-Instruct",
  "released": "2024-09-16"
 },
 {
  "id": "qwen2.5-coder-32b",
  "label": "Qwen2.5-Coder 32B",
  "group": "Coding models",
  "params": 32.763876352,
  "hidden": 5120,
  "layers": 64,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 64,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "64 layers · 64 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen2.5-Coder-32B-Instruct",
  "released": "2024-11-06"
 },
 {
  "id": "kimi-k2.7-code",
  "label": "Kimi-K2.7-Code (MoE)",
  "group": "Large MoE",
  "params": 1026.879376368,
  "activeParams": 33,
  "hidden": 7168,
  "layers": 61,
  "vocab": 163840,
  "maxContext": 262144,
  "routing": {
   "experts": 384,
   "active": 8
  },
  "kv": [
   {
    "layers": 61,
    "width": 576
   }
  ],
  "native": {
   "label": "INT4 (native)",
   "bytes": 595177988208
  },
  "arch": "61 layers · MLA (512 + 64 latent) on 61",
  "repo": "moonshotai/Kimi-K2.7-Code",
  "released": "2026-06-11",
  "parts": {
   "vision": 0.471,
   "experts": 1014.686
  }
 },
 {
  "id": "kimi-k2.5",
  "label": "Kimi-K2.5 (MoE)",
  "group": "Large MoE",
  "params": 1026.879376368,
  "activeParams": 33,
  "hidden": 7168,
  "layers": 61,
  "vocab": 163840,
  "maxContext": 262144,
  "routing": {
   "experts": 384,
   "active": 8
  },
  "kv": [
   {
    "layers": 61,
    "width": 576
   }
  ],
  "native": {
   "label": "INT4 (native)",
   "bytes": 595177988208
  },
  "arch": "61 layers · MLA (512 + 64 latent) on 61",
  "repo": "moonshotai/Kimi-K2.5",
  "released": "2026-01-01",
  "parts": {
   "vision": 0.471,
   "experts": 1014.686
  }
 },
 {
  "id": "kimi-k2",
  "label": "Kimi-K2 (MoE)",
  "group": "Large MoE",
  "params": 1026.408235864,
  "activeParams": 33,
  "hidden": 7168,
  "layers": 61,
  "vocab": 163840,
  "maxContext": 131072,
  "routing": {
   "experts": 384,
   "active": 8
  },
  "kv": [
   {
    "layers": 61,
    "width": 576
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 1029190981272
  },
  "arch": "61 layers · MLA (512 + 64 latent) on 61",
  "repo": "moonshotai/Kimi-K2-Instruct",
  "released": "2025-07-11",
  "parts": {
   "experts": 1014.686
  }
 },
 {
  "id": "glm-5.2",
  "label": "GLM-5.2 (MoE)",
  "group": "Large MoE",
  "params": 753.32994048,
  "activeParams": 42,
  "hidden": 6144,
  "layers": 78,
  "vocab": 154880,
  "maxContext": 1048576,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 78,
    "width": 576,
    "fp8Bytes": 656
   },
   {
    "layers": 21,
    "width": 128,
    "fixedBytes": 132
   }
  ],
  "arch": "78 layers · MLA (512 + 64 latent) on 78 · indexer keys on 21",
  "repo": "zai-org/GLM-5.2",
  "released": "2026-06-16",
  "parts": {
   "mtp": 9.953,
   "experts": 724.776
  },
  "mtpBytes": 19905841664
 },
 {
  "id": "glm-5.1",
  "label": "GLM-5.1 (MoE)",
  "group": "Large MoE",
  "params": 753.864139008,
  "activeParams": 42,
  "hidden": 6144,
  "layers": 78,
  "vocab": 154880,
  "maxContext": 202752,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 78,
    "width": 576,
    "fp8Bytes": 656
   },
   {
    "layers": 78,
    "width": 128,
    "fixedBytes": 132
   }
  ],
  "arch": "78 layers · MLA (512 + 64 latent) on 78 · indexer keys on 78",
  "repo": "zai-org/GLM-5.1",
  "released": "2026-04-03",
  "parts": {
   "mtp": 9.953,
   "experts": 724.776
  },
  "mtpBytes": 19905841664
 },
 {
  "id": "glm-5",
  "label": "GLM-5 (MoE)",
  "group": "Large MoE",
  "params": 753.864139008,
  "activeParams": 42,
  "hidden": 6144,
  "layers": 78,
  "vocab": 154880,
  "maxContext": 202752,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 78,
    "width": 576,
    "fp8Bytes": 656
   },
   {
    "layers": 78,
    "width": 128,
    "fixedBytes": 132
   }
  ],
  "arch": "78 layers · MLA (512 + 64 latent) on 78 · indexer keys on 78",
  "repo": "zai-org/GLM-5",
  "released": "2026-02-11",
  "parts": {
   "mtp": 9.953,
   "experts": 724.776
  },
  "mtpBytes": 19905841664
 },
 {
  "id": "minimax-m2.5",
  "label": "MiniMax-M2.5 (MoE)",
  "group": "Large MoE",
  "params": 228.689764864,
  "activeParams": 10,
  "hidden": 3072,
  "layers": 62,
  "vocab": 200064,
  "maxContext": 196608,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 1536
  },
  "kv": [
   {
    "layers": 62,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 230134264560
  },
  "arch": "62 layers · 62 full attention (8 KV × 128)",
  "repo": "MiniMaxAI/MiniMax-M2.5",
  "released": "2026-02-12",
  "parts": {
   "experts": 224.68
  }
 },
 {
  "id": "minimax-m2",
  "label": "MiniMax-M2 (MoE)",
  "group": "Large MoE",
  "params": 228.689764864,
  "activeParams": 11,
  "hidden": 3072,
  "layers": 62,
  "vocab": 200064,
  "maxContext": 196608,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 62,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 230134264792
  },
  "arch": "62 layers · 62 full attention (8 KV × 128)",
  "repo": "MiniMaxAI/MiniMax-M2",
  "released": "2025-10-22",
  "parts": {
   "experts": 224.68
  }
 },
 {
  "id": "mimo-v2.5",
  "label": "MiMo-V2.5 (MoE)",
  "group": "Large MoE",
  "params": 310.756322688,
  "activeParams": 15,
  "hidden": 4096,
  "layers": 48,
  "vocab": 152576,
  "maxContext": 1048576,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 2048
  },
  "kv": [
   {
    "layers": 9,
    "width": 1280,
    "tpHeads": 4
   },
   {
    "layers": 39,
    "width": 2560,
    "tpHeads": 8,
    "window": 128
   }
  ],
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 315040382024
  },
  "arch": "48 layers · 9 full attention (4 KV × 192, values 128) · 39 sliding-window layers (128 tokens, 8 KV × 192)",
  "repo": "XiaomiMiMo/MiMo-V2.5",
  "released": "2026-04-27",
  "parts": {
   "mtp": 0.988,
   "vision": 0.964,
   "experts": 302.795
  },
  "mtpBytes": 1189400448
 },
 {
  "id": "ornith-1.0-397b",
  "label": "Ornith-1.0 397B (MoE)",
  "group": "Large MoE",
  "params": 396.802360816,
  "activeParams": 11,
  "hidden": 4096,
  "layers": 60,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 512,
   "active": 10
  },
  "kv": [
   {
    "layers": 15,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 192061440,
  "arch": "60 layers · 15 full attention (2 KV × 256) · 45 linear attention",
  "repo": "ornith-ai/Ornith-1.0-397B",
  "released": "2026-06-23",
  "parts": {
   "vision": 0.456,
   "experts": 386.547,
   "odd": 0.002
  }
 },
 {
  "id": "qwen2.5-coder-3b",
  "label": "Qwen2.5-Coder 3B",
  "group": "Coding models",
  "params": 3.085938688,
  "hidden": 2048,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 36,
    "width": 512,
    "tpHeads": 2
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 36 full attention (2 KV × 128)",
  "repo": "Qwen/Qwen2.5-Coder-3B-Instruct",
  "released": "2024-11-06"
 },
 {
  "id": "qwen3-235b-a22b",
  "label": "Qwen3 235B-A22B (MoE)",
  "group": "Large MoE",
  "params": 235.09363456,
  "activeParams": 22,
  "hidden": 4096,
  "layers": 94,
  "vocab": 151936,
  "maxContext": 131072,
  "yarn": {
   "factor": 4,
   "original": 32768,
   "native": 40960
  },
  "routing": {
   "experts": 128,
   "active": 8,
   "ffn": 1536
  },
  "kv": [
   {
    "layers": 94,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "94 layers · 94 full attention (4 KV × 128) · 32K native, 128K with YaRN",
  "repo": "Qwen/Qwen3-235B-A22B",
  "released": "2025-04-27",
  "parts": {
   "experts": 227.096
  }
 },
 {
  "id": "qwen3.5-397b-a17b",
  "label": "Qwen3.5 397B-A17B (MoE)",
  "group": "Large MoE",
  "params": 403.397928944,
  "activeParams": 17,
  "hidden": 4096,
  "layers": 60,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 512,
   "active": 10
  },
  "kv": [
   {
    "layers": 15,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 192061440,
  "arch": "60 layers · 15 full attention (2 KV × 256) · 45 linear attention",
  "repo": "Qwen/Qwen3.5-397B-A17B",
  "released": "2026-02-16",
  "parts": {
   "mtp": 6.596,
   "vision": 0.456,
   "experts": 386.547,
   "odd": 0.002
  },
  "mtpBytes": 13191136256
 },
 {
  "id": "gemma-4-e4b",
  "label": "gemma-4-E4B",
  "group": "Sliding-window attention",
  "params": 7.99615649,
  "hidden": 2560,
  "layers": 42,
  "vocab": 262144,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 7,
    "width": 2048,
    "tpHeads": 2
   },
   {
    "layers": 35,
    "width": 1024,
    "tpHeads": 2,
    "window": 512
   }
  ],
  "tiedEmbeddings": true,
  "arch": "42 layers · 7 full attention (2 KV × 512) · 35 sliding-window layers (512 tokens, 2 KV × 256)",
  "repo": "google/gemma-4-E4B-it",
  "released": "2026-03-02",
  "parts": {
   "vision": 0.478
  }
 },
 {
  "id": "gemma-4-e2b",
  "label": "gemma-4-E2B",
  "group": "Sliding-window attention",
  "params": 5.123178051,
  "hidden": 1536,
  "layers": 35,
  "vocab": 262144,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 7,
    "width": 1024,
    "tpHeads": 1
   },
   {
    "layers": 28,
    "width": 512,
    "tpHeads": 1,
    "window": 512
   }
  ],
  "tiedEmbeddings": true,
  "arch": "35 layers · 7 full attention (1 KV × 512) · 28 sliding-window layers (512 tokens, 1 KV × 256)",
  "repo": "google/gemma-4-E2B-it",
  "released": "2026-03-02",
  "parts": {
   "vision": 0.476
  }
 },
 {
  "id": "nvidia-nemotron-3-nano-4b",
  "label": "NVIDIA-Nemotron-3-Nano 4B",
  "group": "Hybrid Mamba",
  "params": 3.973556832,
  "hidden": 3136,
  "layers": 42,
  "vocab": 131072,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 4,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "stateBytesPerSeq": 83801088,
  "arch": "42 layers · 4 full attention (8 KV × 128) · 21 Mamba-2",
  "repo": "nvidia/NVIDIA-Nemotron-3-Nano-4B-BF16",
  "released": "2026-03-07",
  "parts": {
   "odd": 2.323
  }
 },
 {
  "id": "nvidia-nemotron-3.5-lightning-30b-a3b",
  "label": "NVIDIA-Nemotron-3.5-Lightning 30B-A3B (MoE)",
  "group": "Mixture of experts",
  "params": 32.91326624,
  "activeParams": 3,
  "hidden": 2688,
  "layers": 52,
  "vocab": 131072,
  "maxContext": 262144,
  "routing": {
   "experts": 128,
   "active": 6,
   "ffn": 1856
  },
  "kv": [
   {
    "layers": 6,
    "width": 512,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 49082368,
  "arch": "52 layers · 6 full attention (2 KV × 128) · 23 Mamba-2",
  "repo": "nvidia/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16",
  "released": "2026-08-01",
  "parts": {
   "mtp": 1.335,
   "experts": 29.375,
   "odd": 30.906
  },
  "mtpBytes": 2670652160
 },
 {
  "id": "minicpm-v-4.7-35b-a3b",
  "label": "MiniCPM-V-4.7 35B-A3B (MoE)",
  "group": "Hybrid linear attention",
  "params": 35.212875824,
  "activeParams": 3,
  "hidden": 2048,
  "layers": 40,
  "vocab": 248144,
  "maxContext": 262144,
  "routing": {
   "experts": 256,
   "active": 8
  },
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 64389120,
  "arch": "40 layers · 10 full attention (2 KV × 256) · 30 linear attention",
  "repo": "openbmb/MiniCPM-V-4.7-35B-A3B",
  "released": "2026-10-07",
  "parts": {
   "vision": 0.522,
   "experts": 32.212,
   "odd": 0.001
  }
 },
 {
  "id": "lfm2.5-24b-a2b",
  "label": "LFM2.5 24B-A2B (MoE)",
  "group": "Hybrid linear attention",
  "params": 23.971587712,
  "activeParams": 2,
  "hidden": 2048,
  "layers": 40,
  "vocab": 128000,
  "maxContext": 131072,
  "routing": {
   "experts": 64,
   "active": 4
  },
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 8
   }
  ],
  "stateBytesPerSeq": 368640,
  "tiedEmbeddings": true,
  "arch": "40 layers · 10 full attention (8 KV × 64) · 30 short-convolution layers",
  "repo": "LiquidAI/LFM2.5-24B-A2B",
  "released": "2026-10-12",
  "parts": {
   "experts": 22.951
  }
 },
 {
  "id": "glm-4.7",
  "label": "GLM-4.7 (MoE)",
  "group": "Large MoE",
  "params": 358.337791296,
  "activeParams": 33,
  "hidden": 5120,
  "layers": 92,
  "vocab": 151552,
  "maxContext": 202752,
  "routing": {
   "experts": 160,
   "active": 8
  },
  "kv": [
   {
    "layers": 92,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "92 layers · 92 full attention (8 KV × 128)",
  "repo": "zai-org/GLM-4.7",
  "released": "2025-12-22",
  "parts": {
   "mtp": 5.54,
   "experts": 335.964
  },
  "mtpBytes": 11079924864
 },
 {
  "id": "qwen3-vl-8b",
  "label": "Qwen3-VL 8B",
  "group": "Dense",
  "params": 8.767123696,
  "hidden": 4096,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "36 layers · 36 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen3-VL-8B-Instruct",
  "released": "2025-10-11",
  "parts": {
   "vision": 0.576
  }
 },
 {
  "id": "qwen2.5-vl-7b",
  "label": "Qwen2.5-VL 7B",
  "group": "Dense",
  "params": 8.292166656,
  "hidden": 3584,
  "layers": 28,
  "vocab": 152064,
  "maxContext": 128000,
  "kv": [
   {
    "layers": 28,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "28 layers · 28 full attention (4 KV × 128)",
  "repo": "Qwen/Qwen2.5-VL-7B-Instruct",
  "released": "2025-01-26",
  "parts": {
   "vision": 0.677
  }
 },
 {
  "id": "qwen3-vl-4b",
  "label": "Qwen3-VL 4B",
  "group": "Dense",
  "params": 4.437815808,
  "hidden": 2560,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 36 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen3-VL-4B-Instruct",
  "released": "2025-10-11",
  "parts": {
   "vision": 0.415
  }
 },
 {
  "id": "qwen2.5-vl-3b",
  "label": "Qwen2.5-VL 3B",
  "group": "Dense",
  "params": 3.754622976,
  "hidden": 2048,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 128000,
  "kv": [
   {
    "layers": 36,
    "width": 512,
    "tpHeads": 2
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 36 full attention (2 KV × 128)",
  "repo": "Qwen/Qwen2.5-VL-3B-Instruct",
  "released": "2025-01-26",
  "parts": {
   "vision": 0.669
  }
 },
 {
  "id": "qwen2.5-vl-32b",
  "label": "Qwen2.5-VL 32B",
  "group": "Dense",
  "params": 33.452718336,
  "hidden": 5120,
  "layers": 64,
  "vocab": 152064,
  "maxContext": 128000,
  "kv": [
   {
    "layers": 64,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "64 layers · 64 full attention (8 KV × 128)",
  "repo": "Qwen/Qwen2.5-VL-32B-Instruct",
  "released": "2025-03-21",
  "parts": {
   "vision": 0.689
  }
 },
 {
  "id": "qwen2-vl-7b",
  "label": "Qwen2-VL 7B",
  "group": "Dense",
  "params": 8.291375616,
  "hidden": 3584,
  "layers": 28,
  "vocab": 152064,
  "maxContext": 32768,
  "kv": [
   {
    "layers": 28,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "28 layers · 28 full attention (4 KV × 128)",
  "repo": "Qwen/Qwen2-VL-7B-Instruct",
  "released": "2024-08-28",
  "parts": {
   "vision": 0.676
  }
 },
 {
  "id": "glm-4.5-air",
  "label": "GLM-4.5-Air (MoE)",
  "group": "Mixture of experts",
  "params": 110.468824832,
  "activeParams": 13,
  "hidden": 4096,
  "layers": 46,
  "vocab": 151552,
  "maxContext": 131072,
  "routing": {
   "experts": 128,
   "active": 8
  },
  "kv": [
   {
    "layers": 46,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "46 layers · 46 full attention (8 KV × 128)",
  "repo": "zai-org/GLM-4.5-Air",
  "released": "2025-07-20",
  "parts": {
   "mtp": 3.617,
   "experts": 99.657,
   "odd": 33.523
  },
  "mtpBytes": 7233147392
 },
 {
  "id": "glm-4.5",
  "label": "GLM-4.5 (MoE)",
  "group": "Large MoE",
  "params": 358.337791296,
  "activeParams": 33,
  "hidden": 5120,
  "layers": 92,
  "vocab": 151552,
  "maxContext": 131072,
  "routing": {
   "experts": 160,
   "active": 8
  },
  "kv": [
   {
    "layers": 92,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "92 layers · 92 full attention (8 KV × 128)",
  "repo": "zai-org/GLM-4.5",
  "released": "2025-07-20",
  "parts": {
   "mtp": 5.54,
   "experts": 335.964
  },
  "mtpBytes": 11079924864
 },
 {
  "id": "phi-4",
  "label": "phi-4",
  "group": "Dense",
  "params": 14.6595072,
  "hidden": 5120,
  "layers": 40,
  "vocab": 100352,
  "maxContext": 16384,
  "kv": [
   {
    "layers": 40,
    "width": 2560,
    "tpHeads": 10
   }
  ],
  "arch": "40 layers · 40 full attention (10 KV × 128)",
  "repo": "microsoft/phi-4",
  "released": "2024-12-11"
 },
 {
  "id": "phi-3.5-mini",
  "label": "Phi-3.5-mini",
  "group": "Dense",
  "params": 3.821079552,
  "hidden": 3072,
  "layers": 32,
  "vocab": 32064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 32,
    "width": 6144,
    "tpHeads": 32
   }
  ],
  "arch": "32 layers · 32 full attention (32 KV × 96)",
  "repo": "microsoft/Phi-3.5-mini-instruct",
  "released": "2024-08-16"
 },
 {
  "id": "phi-4-mini",
  "label": "Phi-4-mini",
  "group": "Dense",
  "params": 3.83602176,
  "hidden": 3072,
  "layers": 32,
  "vocab": 200064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 32,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "tiedEmbeddings": true,
  "arch": "32 layers · 32 full attention (8 KV × 128)",
  "repo": "microsoft/Phi-4-mini-instruct",
  "released": "2025-02-19"
 },
 {
  "id": "phi-3-mini-128k",
  "label": "Phi-3-mini-128k",
  "group": "Dense",
  "params": 3.821079552,
  "hidden": 3072,
  "layers": 32,
  "vocab": 32064,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 32,
    "width": 6144,
    "tpHeads": 32
   }
  ],
  "arch": "32 layers · 32 full attention (32 KV × 96)",
  "repo": "microsoft/Phi-3-mini-128k-instruct",
  "released": "2024-04-22"
 },
 {
  "id": "unlimited-ocr",
  "label": "Unlimited-OCR (MoE)",
  "group": "Sliding-window attention",
  "params": 3.33610624,
  "activeParams": 0.7,
  "hidden": 1280,
  "layers": 12,
  "vocab": 129280,
  "maxContext": 32768,
  "routing": {
   "experts": 64,
   "active": 6,
   "ffn": 896
  },
  "kv": [
   {
    "layers": 12,
    "width": 2560,
    "tpHeads": 10,
    "window": 128
   }
  ],
  "arch": "12 layers · 12 sliding-window layers (128 tokens, 10 KV × 128)",
  "repo": "baidu/Unlimited-OCR",
  "released": "2026-06-19",
  "parts": {
   "vision": 0.304,
   "experts": 2.422,
   "odd": 0.823
  }
 },
 {
  "id": "ling-3.1-flash",
  "label": "Ling-3.1-flash (MoE)",
  "group": "Large MoE",
  "params": 572.120680768,
  "activeParams": 24,
  "hidden": 4096,
  "layers": 72,
  "vocab": 157184,
  "maxContext": 262144,
  "routing": {
   "experts": 512,
   "active": 8,
   "ffn": 1280
  },
  "kv": [
   {
    "layers": 9,
    "width": 576
   }
  ],
  "stateBytesPerSeq": 273530880,
  "native": {
   "label": "FP8 (native)",
   "needs": "fp8",
   "bytes": 573781078249
  },
  "arch": "72 layers · MLA (512 + 64 latent) on 9 · 63 Kimi Delta Attention",
  "repo": "inclusionAI/Ling-3.1-flash",
  "released": "2026-10-13",
  "parts": {
   "mtp": 8.174,
   "experts": 547.608,
   "odd": 0.006
  },
  "mtpBytes": 8211859968
 },
 {
  "id": "step-5-preview",
  "label": "Step-5-Preview (MoE)",
  "group": "Large MoE",
  "params": 604.339504832,
  "activeParams": 33,
  "hidden": 4096,
  "layers": 92,
  "vocab": 128896,
  "maxContext": 1048576,
  "routing": {
   "experts": 352,
   "active": 8,
   "ffn": 1536
  },
  "kv": [
   {
    "layers": 23,
    "width": 1536,
    "tpHeads": 4
   },
   {
    "layers": 23,
    "width": 256,
    "ratio": 8,
    "fixedBytes": 256
   },
   {
    "layers": 69,
    "width": 1536,
    "tpHeads": 4,
    "window": 512
   }
  ],
  "arch": "92 layers · 23 full attention (4 KV × 192) · sparse attention, a summary per 8-token block · 69 sliding-window layers (512 tokens, 4 KV × 192)",
  "repo": "stepfun-ai/Step-5-Preview-BF16",
  "released": "2026-09-20",
  "parts": {
   "mtp": 3.354,
   "vision": 1.956
  },
  "mtpBytes": 6709123072
 },
 {
  "id": "hy3",
  "label": "Hy3 (MoE)",
  "group": "Large MoE",
  "params": 298.786155776,
  "activeParams": 20,
  "hidden": 4096,
  "layers": 80,
  "vocab": 120832,
  "maxContext": 262144,
  "routing": {
   "experts": 192,
   "active": 8,
   "ffn": 1536
  },
  "kv": [
   {
    "layers": 80,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "80 layers · 80 full attention (8 KV × 128)",
  "repo": "tencent/Hy3",
  "released": "2026-07-02",
  "parts": {
   "mtp": 3.753,
   "experts": 286.286
  },
  "mtpBytes": 7505224960
 },
 {
  "id": "ornith-1.5-122b",
  "label": "Ornith-1.5 122B (MoE)",
  "group": "Hybrid linear attention",
  "params": 125.086497008,
  "activeParams": 9,
  "hidden": 3072,
  "layers": 48,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 1024
  },
  "kv": [
   {
    "layers": 12,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 153649152,
  "arch": "48 layers · 12 full attention (2 KV × 256) · 36 linear attention",
  "repo": "ornith-ai/Ornith-1.5-122B",
  "released": "2026-10-20",
  "parts": {
   "mtp": 2.524,
   "vision": 0.451,
   "experts": 115.964,
   "odd": 0.002
  },
  "mtpBytes": 5047358464
 },
 {
  "id": "spark-x2.6-4b",
  "label": "Spark-X2.6 4B",
  "group": "Sliding-window attention",
  "params": 4.11207936,
  "hidden": 2560,
  "layers": 36,
  "vocab": 131072,
  "maxContext": 1048576,
  "kv": [
   {
    "layers": 9,
    "width": 2048,
    "tpHeads": 4
   },
   {
    "layers": 27,
    "width": 2048,
    "tpHeads": 4,
    "window": 512
   }
  ],
  "tiedEmbeddings": true,
  "arch": "36 layers · 9 full attention (4 KV × 256) · 27 sliding-window layers (512 tokens, 4 KV × 256)",
  "repo": "XHToken/Spark-X2.6-4B",
  "released": "2026-10-19"
 },
 {
  "id": "sage-a1.5",
  "label": "Sage-A1.5 (MoE)",
  "group": "Hybrid linear attention",
  "params": 35.951822704,
  "activeParams": 2.9,
  "hidden": 2048,
  "layers": 40,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 512
  },
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 64389120,
  "arch": "40 layers · 10 full attention (2 KV × 256) · 30 linear attention",
  "repo": "InternScience/Sage-A1.5",
  "released": "2026-10-15",
  "parts": {
   "mtp": 0.845,
   "vision": 0.447,
   "experts": 32.212,
   "odd": 0.001
  },
  "mtpBytes": 1689281536
 },
 {
  "id": "mlexpert",
  "label": "MLExpert (MoE)",
  "group": "Hybrid linear attention",
  "params": 34.660610688,
  "activeParams": 2.9,
  "hidden": 2048,
  "layers": 40,
  "vocab": 248320,
  "maxContext": 262144,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 512
  },
  "kv": [
   {
    "layers": 10,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 64389120,
  "arch": "40 layers · 10 full attention (2 KV × 256) · 30 linear attention",
  "repo": "InternScience/MLExpert",
  "released": "2026-10-01",
  "parts": {
   "experts": 32.212,
   "odd": 0.001
  }
 },
 {
  "id": "agents-a1-4b",
  "label": "Agents-A1 4B",
  "group": "Hybrid linear attention",
  "params": 4.539265536,
  "hidden": 2560,
  "layers": 32,
  "vocab": 248320,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 8,
    "width": 2048,
    "tpHeads": 4
   }
  ],
  "stateBytesPerSeq": 51511296,
  "tiedEmbeddings": true,
  "arch": "32 layers · 8 full attention (4 KV × 256) · 24 linear attention",
  "repo": "InternScience/Agents-A1-4B",
  "released": "2026-07-13",
  "parts": {
   "vision": 0.334,
   "odd": 0.001
  }
 },
 {
  "id": "ling-3.0-flash-sante",
  "label": "Ling-3.0-flash-Sante (MoE)",
  "group": "Hybrid linear attention",
  "params": 127.4864056,
  "activeParams": 5.1,
  "hidden": 2560,
  "layers": 42,
  "vocab": 157184,
  "maxContext": 262144,
  "routing": {
   "experts": 512,
   "active": 8,
   "ffn": 768
  },
  "kv": [
   {
    "layers": 7,
    "width": 576
   }
  ],
  "stateBytesPerSeq": 75980800,
  "arch": "42 layers · MLA (512 + 64 latent) on 7 · 35 Kimi Delta Attention",
  "repo": "inclusionAI/Ling-3.0-flash-Sante",
  "released": "2026-10-22",
  "parts": {
   "mtp": 3.072,
   "experts": 120.796,
   "odd": 0.002
  },
  "mtpBytes": 6144389120
 },
 {
  "id": "atria-dawn",
  "label": "Atria-Dawn (MoE)",
  "group": "Large MoE",
  "params": 753.32994048,
  "activeParams": 40,
  "hidden": 6144,
  "layers": 78,
  "vocab": 154880,
  "maxContext": 1048576,
  "routing": {
   "experts": 256,
   "active": 8,
   "ffn": 2048
  },
  "kv": [
   {
    "layers": 78,
    "width": 576,
    "fp8Bytes": 656
   },
   {
    "layers": 21,
    "width": 128,
    "fixedBytes": 132
   }
  ],
  "arch": "78 layers · MLA (512 + 64 latent) on 78 · indexer keys on 21",
  "repo": "internlm/Atria-Dawn",
  "released": "2026-10-23",
  "parts": {
   "mtp": 9.953,
   "experts": 724.776
  },
  "mtpBytes": 19905841664
 },
 {
  "id": "minicpm-ocr-1.0",
  "label": "MiniCPM-OCR-1.0",
  "group": "Hybrid linear attention",
  "params": 1.30043416,
  "hidden": 1024,
  "layers": 24,
  "vocab": 248100,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 6,
    "width": 1024,
    "tpHeads": 2
   }
  ],
  "stateBytesPerSeq": 19537920,
  "tiedEmbeddings": true,
  "arch": "24 layers · 6 full attention (2 KV × 256) · 18 linear attention",
  "repo": "openbmb/MiniCPM-OCR-1.0",
  "released": "2026-10-28",
  "parts": {
   "vision": 0.522
  }
 },
 {
  "id": "wevisone-vl-4b",
  "label": "WeVisOne-VL 4B",
  "group": "Dense",
  "params": 4.830581248,
  "hidden": 2560,
  "layers": 36,
  "vocab": 152680,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "36 layers · 36 full attention (8 KV × 128)",
  "repo": "tencent/WeVisOne-VL-4B",
  "released": "2026-10-22",
  "parts": {
   "vision": 0.415
  }
 },
 {
  "id": "lfm3-1.7b-base",
  "label": "LFM3 1.7B-Base",
  "group": "Hybrid linear attention",
  "params": 1.728801536,
  "hidden": 2048,
  "layers": 24,
  "vocab": 128000,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 6,
    "width": 1024,
    "tpHeads": 4
   },
   {
    "layers": 5,
    "width": 1024,
    "tpHeads": 4,
    "window": 256
   }
  ],
  "stateBytesPerSeq": 372736,
  "tiedEmbeddings": true,
  "arch": "24 layers · 6 full attention (4 KV × 128) · 5 sliding-window layers (256 tokens, 4 KV × 128) · 13 short-convolution layers",
  "repo": "LiquidAI/LFM3-1.7B-Base",
  "released": "2026-10-29"
 },
 {
  "id": "granite-4.1-3b",
  "label": "Granite 4.1 3B",
  "group": "Dense",
  "params": 3.40283648,
  "hidden": 2560,
  "layers": 40,
  "vocab": 100352,
  "maxContext": 131072,
  "kv": [
   {
    "layers": 40,
    "width": 1024,
    "tpHeads": 8
   }
  ],
  "tiedEmbeddings": true,
  "arch": "40 layers · 40 full attention (8 KV × 64)",
  "repo": "ibm-granite/granite-4.1-3b",
  "released": "2026-04-06"
 },
 {
  "id": "qwen3-vl-30b-a3b",
  "label": "Qwen3-VL 30B-A3B (MoE)",
  "group": "Mixture of experts",
  "params": 31.070754032,
  "activeParams": 3,
  "hidden": 2048,
  "layers": 48,
  "vocab": 151936,
  "maxContext": 262144,
  "routing": {
   "experts": 128,
   "active": 8,
   "ffn": 768
  },
  "kv": [
   {
    "layers": 48,
    "width": 1024,
    "tpHeads": 4
   }
  ],
  "arch": "48 layers · 48 full attention (4 KV × 128)",
  "repo": "Qwen/Qwen3-VL-30B-A3B-Instruct",
  "released": "2025-09-30",
  "parts": {
   "vision": 0.539,
   "experts": 28.991
  }
 },
 {
  "id": "mage-vl-cowork",
  "label": "Mage-VL-Cowork",
  "group": "Dense",
  "params": 4.741793792,
  "hidden": 2560,
  "layers": 36,
  "vocab": 151936,
  "maxContext": 262144,
  "kv": [
   {
    "layers": 36,
    "width": 2048,
    "tpHeads": 8
   }
  ],
  "arch": "36 layers · 36 full attention (8 KV × 128)",
  "repo": "microsoft/Mage-VL-Cowork",
  "released": "2026-10-30",
  "parts": {
   "vision": 0.33
  }
 },
 {
  "id": "spark-x2.6-1.7b",
  "label": "Spark-X2.6 1.7B",
  "group": "Sliding-window attention",
  "params": 1.707657216,
  "hidden": 2048,
  "layers": 28,
  "vocab": 131072,
  "maxContext": 1048576,
  "kv": [
   {
    "layers": 7,
    "width": 1024,
    "tpHeads": 2
   },
   {
    "layers": 21,
    "width": 1024,
    "tpHeads": 2,
    "window": 512
   }
  ],
  "tiedEmbeddings": true,
  "arch": "28 layers · 7 full attention (2 KV × 256) · 21 sliding-window layers (512 tokens, 2 KV × 256)",
  "repo": "XHToken/Spark-X2.6-1.7B",
  "released": "2026-10-27"
 }
]
